import { render, staticRenderFns } from "./barcodeBindRecord.vue?vue&type=template&id=4811c89f&scoped=true&"
import script from "./barcodeBindRecord.vue?vue&type=script&lang=js&"
export * from "./barcodeBindRecord.vue?vue&type=script&lang=js&"
import style0 from "./barcodeBindRecord.vue?vue&type=style&index=0&id=4811c89f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811c89f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4811c89f')) {
      api.createRecord('4811c89f', component.options)
    } else {
      api.reload('4811c89f', component.options)
    }
    module.hot.accept("./barcodeBindRecord.vue?vue&type=template&id=4811c89f&scoped=true&", function () {
      api.rerender('4811c89f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/barcodeBindRecord.vue"
export default component.exports